<script setup lang="ts">
import type { ButtonProps } from '#layers/ui/components/Button.vue';
import { computed } from 'vue';
import { useAppConfig } from '#app/config';
import DButtonDestructive from '#layers/ui/components/Button/Destructive.vue';

defineOptions({
	name: 'ButtonRemove',
});

const {
	withLeadingIcon,
	trashBin = true,
	size = 'sm',
	// eslint-disable-next-line unicorn/no-useless-undefined -- an absent Boolean prop without a default becomes `false`, and NuxtLink rejects `prefetch` and `noPrefetch` both being false
	prefetch = undefined,
	// eslint-disable-next-line unicorn/no-useless-undefined -- an absent Boolean prop without a default becomes `false`, and NuxtLink rejects `prefetch` and `noPrefetch` both being false
	noPrefetch = undefined,
	...forwardedProps
} = defineProps<{
	withLeadingIcon?: boolean;
	trashBin?: boolean;
} & Partial<ButtonProps>>();

const appConfig = useAppConfig();
const forward = computed(() => ({ ...forwardedProps, size, prefetch, noPrefetch }));
</script>

<template>
	<DButtonDestructive
		v-bind="forward"
		:leading-icon="withLeadingIcon ? trashBin ? appConfig.ui.icons.trash : appConfig.ui.icons.close : undefined"
		:aria-label="label ?? $t('common.remove')"
	>
		<slot />
	</DButtonDestructive>
</template>
